const PagingMixin = {
    data() {
        return {
            totalResult: 0,
            currentPage: 1,
            perPage: 10,
            totalPage: 1,
            pageOptions: [10, 50, 100],
        };
    },
    computed: {
        detailPaging() {
            let fromNumber = ((this.currentPage - 1) * this.perPage) + 1;
            let toNumber = this.totalResult >= (this.currentPage * this.perPage) ? (this.currentPage * this.perPage) : this.totalResult;
            return `Hiển thị ${fromNumber} - ${toNumber} / Tổng số ${this.totalResult}`;
        }
    },
    methods: {
        async onChangePage(page) {
            this.currentPage = page;
            await this.onSearch(page);
        },
    }
};

export default PagingMixin;